import React from 'react';
import { Button } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface TourButtonProps {
  onClick: () => void;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  className?: string;
}

export const TourButton: React.FC<TourButtonProps> = ({
  onClick,
  disabled = false,
  size = 'middle',
  style,
  className = 'tour-button'
}) => {
  const { t } = useTranslation('common');

  return (
    <Button
      type="primary"
      icon={<PlayCircleOutlined />}
      onClick={onClick}
      disabled={disabled}
      size={size}
      className={className}
      style={{
        background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
        border: 'none',
        boxShadow: '0 2px 8px rgba(24, 144, 255, 0.3)',
        ...style
      }}
    >
      {t('common:startTour', 'Start Guided Tour')}
    </Button>
  );
};
